import { render } from "./ApiToken.vue?vue&type=template&id=275ada2c"
import script from "./ApiToken.vue?vue&type=script&lang=js"
export * from "./ApiToken.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fLte45evJ/0/trinax/jeopardy.trinax.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__